export var slice = Array.prototype.slice;



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-shape/src/array.js
// module id = 96
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 13